import { AxiosResponse } from "axios";
import { OrganisationLinkedScorecard } from "../../Model/Dto/Organisation/OrganisationLinkedScorecard";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";

const route = 'Organisation/LinkedScorecards';

export const OrganisationLinkedScorecardService = {
    SearchLinkedScorecards: (searchRequest: OrganisationLinkedScorecard.SearchRequest): Promise<AxiosResponse<OrganisationLinkedScorecard.SearchResponse>> =>
        axiosCoreInstance.post(`${route}/Search`, searchRequest),
    UnlinkScorecard: (linkedScorecard: OrganisationLinkedScorecard.Dto): Promise<AxiosResponse<void>> => 
        axiosCoreInstance.delete(`${route}?scorecardId=${linkedScorecard.scorecardId}&organisationId=${linkedScorecard.organisationId}`),
    LinkScorecard: (linkedScorecard: OrganisationLinkedScorecard.Dto) => 
        axiosCoreInstance.post(route, linkedScorecard),
    GetAllScorecardsToLink: (organidationId: number): Promise<AxiosResponse<OrganisationLinkedScorecard.LinkScorecardOptionDto[]>> => 
        axiosCoreInstance.get(`${route}/GetAllScorecardsToLink/${organidationId}`)
};